import { Box, Typography } from "@mui/material";
import { formatNumber } from "src/utils/formatting";

type SalesBoxProps = {
    value: ReactNode | undefined;
    unit: string;
};

export const SalesBox = (props: SalesBoxProps) =>
    props.value ?
        <Box sx={{ display: "flex", gap: ".5rem", alignItems: "center" }}>
            <Typography variant="h5">{formatNumber(props.value.toString())}</Typography>
            <Typography variant="body-medium" sx={{ color: "#A3A2A0" }}>
                {props.unit}
            </Typography>
        </Box>
    :   "-";
